import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import PromosContent from "@Types/promos";
import CartPromoCodesListItem from "./CartPromoCodesListItem";
import "./style.scss";

interface Props {
  onClickPromo: (code: string) => void;
  promos: PromosContent[];
}

const CartPromoCodesList: FunctionComponent<Props> = ({ onClickPromo, promos }) => {
  const intl = useIntl();
  const sortedPromos = [...promos].sort((a, b) => a.priority - b.priority);

  return (
    <div className="CartPromoCodesList">
      <div className="CartPromoCodesList-title">
        {intl.formatMessage({ id: "cheerz_CartPromoCodesList_title" })}
      </div>
      {sortedPromos.map((promo) => {
        return (
          <CartPromoCodesListItem key={promo.code} onClickPromo={onClickPromo} promo={promo} />
        );
      })}
    </div>
  );
};

export default CartPromoCodesList;
